import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const TIME_TOKENS = 'HH:mm:ss';
const DATETIME_TOKENS = `LL ${TIME_TOKENS}`;
const INVALID_STR = 'Invalid Date';

const invalidString = (showInvalid?: boolean | string): string => (showInvalid ? (typeof showInvalid === 'string' ? showInvalid : INVALID_STR) : '');

const getFormatTokens = (value: string, showTimeOnly: boolean, showTimezone: boolean, showUTC = false): string => {
	const timezoneToken = showUTC ? '[UTC]' : `[${getLocalTimezone(value)}]`;
	if (showTimeOnly) return showTimezone ? `${TIME_TOKENS} ${timezoneToken}` : TIME_TOKENS;
	return showTimezone ? `${DATETIME_TOKENS} ${timezoneToken}` : DATETIME_TOKENS;
};

export const toLocalFormattedString = (value: string, showInvalid?: boolean | string, showTimezone = true, showTimeOnly = false): string => {
	const utcDay = dayjs.utc(value);
	if (!utcDay.isValid()) return invalidString(showInvalid);

	const formatTokens = getFormatTokens(value, showTimeOnly, showTimezone, false);
	return utcDay.local().format(formatTokens);
};

export const toUTCFormattedString = (value: string, showInvalid?: boolean | string, showTimezone = true, showTimeOnly = false): string => {
	const utcDay = dayjs.utc(value);
	if (!utcDay.isValid()) return invalidString(showInvalid);

	const formatTokens = getFormatTokens(value, showTimeOnly, showTimezone, true);
	return utcDay.format(formatTokens);
};

export const getLocalTimezone = (value?: string): string => {
	const day = value ? dayjs(value) : dayjs();
	const short = day.local().format('z');
	const long = day.local().format('zzz');
	if (long === 'Coordinated Universal Time') return 'UTC';
	if (long === 'Central European Standard Time') return 'CET';
	if (long === 'Central European Summer Time') return 'CEST';
	return long.match(/\b([a-zA-Z])/g)?.join('') || short;
};

export const getCurrentDateString = (): string => dayjs().format('YYYY-MM-DD');
export const getReportStartDateString = (): string => dayjs().subtract(1, 'day').format('YYYY-MM-DD');
export const getReportEndDateString = (): string => dayjs().add(5, 'day').format('YYYY-MM-DD');

export const addOffsetSeconds = (dt: string | null | undefined, offset: number): string | null | undefined => {
	if (dt) {
		return dayjs(dt).utc().add(offset, 'second').format();
	}

	return dt;
};
